import { render, staticRenderFns } from "./AppPunchInOut.vue?vue&type=template&id=63a0f822"
import script from "./AppPunchInOut.vue?vue&type=script&lang=js"
export * from "./AppPunchInOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports